import React, { useMemo } from "react";
import I18n from "i18n-js";

import Table from "./Table";
import Indicator from "./Indicator";

const indicators = {
  "forming": "red",
  "storming": "yellow",
  "norming": "blue",
  "performing": "green"
}

const makeTableData = (data) => {
  return [...data?.members, { name: I18n.t("common.team"), stage: data?.team }];
}

const TeamStageTable = ({ data, loading }) => {

  const columns = useMemo(() => [
    {
      id: "name",
      accessorKey: "name",
      header: () => <span>{I18n.t("dashboard.team_stage")}</span>,
      cell: info => <span>{info.getValue()}</span>,
      sortUndefined: "last",
      sortDescFirst: false
    },
    {
      id: "stage",
      accessorKey: "stage",
      header: () => <span>{I18n.t("common.stage")}</span>,
      cell: info => (
        <span>
          <Indicator indicator={indicators[info.getValue()]} />
          {I18n.t(`dashboard.${info.getValue()}`)}
        </span>
      ),
      sortUndefined: "last",
      sortDescFirst: false
    }
  ], []);

  return (
    <Table
      columns={columns}
      data={loading ? null : makeTableData(data)}
      loading={loading}
    />
  );
}

export default TeamStageTable;
